<div class="center" style="margin:10px">
  <kendo-card [width]="'100%'">
    <kendo-card-header class="k-hbox">
      <div>
        <h1 kendoCardTitle>Resource Frame</h1>
      </div>
    </kendo-card-header>
    <kendo-card-body>
      <div class="form-group">
        <div class="input-group mb-3" *ngIf="productModel?.resourceFrame?.frameName?.length>0">
          <input type="text" class="form-control" value="{{productModel?.resourceFrame?.frameName}}" disabled>
          <div class="input-group-append">
            <button class="clearKendoButton btn btn-success"
                    (click)="goToFrameConfig('editResourceFrame',-1)"
                    kendoButton>
              Edit
            </button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-3">
          <button class="clearKendoButton btn btn-success"
                  (click)="goToFrameConfig('addResourceFrame',-1)"
                  kendoButton>
            Add Resource Frame
          </button>
        </div>
      </div>
    </kendo-card-body>
  </kendo-card>
  <kendo-card [width]="'100%'">
    <kendo-card-header class="k-hbox">
      <div>
        <h1 kendoCardTitle>Nested Frames</h1>
      </div>
    </kendo-card-header>
    <kendo-card-body>
      <div class="form-group"
           *ngFor="let nestedFrame of productModel.nestedFrames;let nestedFrameIndex=index;"
           style="margin:10px;">

        <div class="input-group mb-3">
          <input type="text" class="form-control" value="{{nestedFrame.frameName}}" disabled>
          <div class="input-group-append">
            <button class="clearKendoButton btn btn-success"
                    (click)="goToFrameConfig('editNestedFrame',nestedFrameIndex)"
                    kendoButton>
              Edit
            </button>
            <button class="clearKendoButton btn btn-success"
            (click)="duplicateNestedFrame('editNestedFrame',nestedFrameIndex)"
            kendoButton>
              Duplicate
           </button>
            <div class="input-group-append">
              <span class="k-icon k-i-minus k-icon-size" style="color: red;"
                    (click)="removeNestedFrame(nestedFrameIndex)"
                    title="Delete"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <button class="clearKendoButton btn btn-success"
                (click)="goToFrameConfig('addNestedFrame',-1)"
                kendoButton>
          Add Nested Frame
        </button>
      </div>

    </kendo-card-body>
  </kendo-card>
  <div class="form-group">
    <button class="m-3 clearKendoButton btn btn-success"
            (click)="goBack()"
            kendoButton>
      Back
    </button>
  </div>
</div>
